/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckA2Icon32Regular = forwardRef('CheckA2Icon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M24.936 8.957a1 1 0 1 0-1.414-1.414L9.857 21.208c-.85.85-2.227.85-3.076 0l-5.074-5.074A1 1 0 0 0 .293 17.55l5.073 5.073a4.175 4.175 0 0 0 5.905 0L24.936 8.957Z" }),
        React.createElement("path", { d: "M31.572 8.957a1 1 0 0 0-1.415-1.414L15.61 22.09a1 1 0 0 0 1.414 1.414L31.572 8.957Z" })));
});
